<template>
    <div class="gray-back" style="padding:.2rem 0 8rem 0 ; height:auto !important">
        <van-form
                @submit="onSubmit"
                @failed="onFailed"
        >
            <van-cell-group>
                <van-field
                        v-model="formData.saiqu_name"
                        label="活动名称"
                        input-align="right"
                        readonly
                /> 
                <van-field
                        readonly
                        clickable
                        right-icon="arrow"
                        input-align="right"
                        @click="showDanweiPicker=true"
                        label="省份/专业公司"
                        v-model="formData.gongsi"
                />
                <van-popup v-model="showDanweiPicker" position="bottom">
                    <van-picker :columns="danweiColumns"
                                show-toolbar
                                value-key="name"
                                :default-index="defaultDanweiIndex"
                                @cancel="showDanweiPicker = false"
                                @confirm="onDanweiConfirm"
                    />
                </van-popup>


                <div v-if="formData.gongsi_id<112638&&formData.gongsi_id>112593">
                    <!-- 需要选择地区 -->
                <!-- <van-field
                        readonly
                        clickable
                        name="area"
                        :value="formData.dx_city?(formData.dx_province+'/'+formData.dx_city):''"
                        input-align="right"
                        label="地区选择"
                        placeholder="点击选择省市"
                        @click="showArea = true"
                />
                <van-popup v-model="showArea" position="bottom">
                    <van-area
                            :area-list="areaList"
                            :columns-num="2"
                            :value="formData.dx_area"
                            @confirm="onAreaConfirm"
                            @cancel="showArea = false"
                    />
                </van-popup> -->


                <van-field
                        readonly
                        clickable
                        right-icon="arrow"
                        input-align="right"
                        @click="showFengongsiPicker=true"
                        label="分公司"
                        v-model="formData.fengongsi"
                />
                <van-popup v-model="showFengongsiPicker" position="bottom">
                    <van-picker :columns="fengongsiColumns"
                                show-toolbar
                                value-key="name"
                                :default-index="defaultFengongsiIndex"
                                @cancel="showFengongsiPicker = false"
                                @confirm="onFengongsiConfirm"
                    />
                </van-popup>

                </div>

                <van-field
                        v-model="formData.mingcheng"
                        :rules="[{ required: true, message: '队伍名称不能为空' }]"
                        label="队伍名称"
                        :border="false"
                        input-align="right"
                        error-message-align="right"
                        clearable
                        placeholder="请输入队伍名称"
                />
                <div class="operate-desc-left" v-show="!formData.mingcheng">队伍名称不能含有英文字母哦~</div>
                <div class="operate-desc-left" v-show="formData.mingcheng">队伍名称不能含有英文字母哦~ <br/>您的队伍全称是

                    <span style="font-weight: bold; font-size: 18px; color: #ff9535">{{formData.danwei}} {{formData.mingcheng}} {{formData.mingcheng_end}}</span></div>


                <van-cell title="队伍照片" :value="formData.heying.length+'/1'">
                    <!--<template slot="icon" >-->
                        <!--<van-icon class="question-icon" name="question-o" @click="onQuestion('heying')"/>-->
                    <!--</template>-->
                </van-cell>

                <div class="row">
                    <PicUploader :fileList="formData.heying" @imageListChange="heyingChange" :limit="1"
                                 :name="'heying'"></PicUploader>
                </div>
                <div class="operate-desc-left">上传一张队伍照片(横版),建议比例3x4</div>

<!-- 
                <van-field
                        v-model="formData.ldname"
                        label="领队姓名"
                        :rules="[{ required: true, message: '领队姓名不能为空' }]"
                        error-message-align="right"
                        input-align="right"
                        clearable
                        placeholder="请输入领队姓名"
                />

                <van-field
                        readonly
                        clickable
                        right-icon="arrow"
                        input-align="right"
                        @click="showNumTypePicker=true"
                        label="证件类型"
                        v-model="formData.numTypeName"
                />
                <van-popup v-model="showNumTypePicker" position="bottom">
                    <van-picker :columns="numTypeColumns"
                                show-toolbar
                                :default-index="formData.ldcardtype-1"
                                @cancel="showNumTypePicker = false"
                                @confirm="onNumTypeConfirm"
                    />
                </van-popup>

                <van-field
                        v-model="formData.ldnum"
                        label="证件号码"
                        :rules="[{ required: true, message: '证件号码不能为空' }]"
                        error-message-align="right"
                        input-align="right"
                        clearable
                        placeholder="请输入证件号码"
                />

                <van-field name="radio" label="领队性别"
                           input-align="right">
                    <template #input>
                        <van-radio-group v-model="formData.ldsex" direction="horizontal">
                            <van-radio checked-color="#ffb01b" :name="1">男</van-radio>
                            <van-radio checked-color="#ffb01b" :name="2">女</van-radio>
                        </van-radio-group>
                    </template>
                </van-field>


                <van-field
                        v-model="formData.phone"
                        :rules="[{ validator: validator.phone,message:'请输入正确的手机号'}]"
                        error-message-align="right"
                        label="领队手机"
                        input-align="right"
                        clearable
                        placeholder="请输入手机"
                /> -->

                <van-field
                        v-model="formData.lxname"
                        label="联系人"
                        :rules="[{ required: true, message: '联系人不能为空' }]"
                        error-message-align="right"
                        input-align="right"
                        clearable
                        placeholder="请输入联系人姓名"
                />
                <div class="operate-desc-left">建议联系人最好是教练员</div>


                <van-field
                        v-model="formData.lxphone"
                        :rules="[{ validator: validator.phone,message:'请输入正确的手机号'}]"
                        error-message-align="right"
                        label="联系人手机"
                        input-align="right"
                        clearable
                        placeholder="请输入手机"
                />


                <van-field
                        v-model="formData.phonecode"
                        label="验证码"
                        :rules="[{ required: true,message:'请输入验证码'}]"
                        error-message-align="right"
                        input-align="right"
                        clearable
                        placeholder="请输入验证码"
                >
                <template #button>
                <van-button @click="getCode" native-type="button" size="small" type="primary" :disabled="clockSecond>0">{{clockSecond>0?
            '('+clockSecond+'s)':'获取验证码'}}</van-button>
                </template>
                </van-field>

            </van-cell-group>


            <!-- <van-divider>教练信息</van-divider> -->

            <van-cell-group v-if="false">
<!-- 
                <van-field
                        readonly
                        clickable
                        right-icon="arrow"
                        input-align="right"
                        label="随队裁判"
                        placeholder="请选择裁判"
                        @click="showCaipanPicker = true"
                />
                <div class="operate-desc-left">如无法全程参与执裁，则无需填写随队裁判</div>


                <div class="memberResultWrap" v-show="formData.caipan.length>0">
                    <div class="memberLi" v-for="(caipan ,index) in formData.caipan" :key=index>
                        裁判员
                        <van-tag

                                :key="index"
                                round
                                color="#fff"
                                text-color="#666"
                                size="large"
                                closeable
                                type="primary"
                                @close="formData.caipan.splice(index,1)"
                        > {{caipan.name}} {{caipan.num}}
                        </van-tag>
                    </div>
                </div> -->

                <van-field
                        readonly
                        clickable
                        right-icon="arrow"
                        input-align="right"
                        label="教练员"
                        placeholder="请选择教练员"
                        @click="showJiaolianPicker = true"
                />

                <div  class="operate-desc-left">如需在获奖证书出现的教练员都需要添加</div>
                <div class="memberResultWrap" v-show="formData.jiaolian.length>0">
                    <!-- <div style="color:#666; margin-bottom:10px">没有等级证书的不发优秀教练员证书</div> -->
                    <div class="memberLi" v-for="(jiaolian ,index) in formData.jiaolian" :key="index">
                        第{{(['一','二','三','四','五'])[index]}}教练员
                        <van-tag
                                :key="index"
                                round
                                color="#fff"
                                text-color="#666"
                                size="large"
                                closeable
                                type="primary"
                                @close="formData.jiaolian.splice(index,1)"
                        > {{jiaolian.name}} {{jiaolian.num}}
                        </van-tag>
                    </div>
                </div>




            </van-cell-group>
            <div  v-if="[648,751,767].indexOf(parseInt(this.saiqu_id))==-1">
            <van-divider>发票抬头信息</van-divider>

            <div style="text-align:center; padding:0 0 10px 0">
                <van-button  
                        style="width: 3rem"
                        size="normal" round   @click="fapiaoPickerShow=true">选择抬头</van-button>
            </div>
            <van-cell-group>

                <van-field
                        v-model="formData.fapiao_taitou"
                        :rules="[{ required: true, message: '发票抬头不能为空' }]"
                        label="发票抬头"
                        input-align="right"
                        error-message-align="right"
                        clearable
                        placeholder="请输入发票抬头"
                />
                <van-field
                        v-model="formData.fapiao_shuihao"
                        :rules="[{ required: true, message: '税号不能为空' }]"
                        label="税号"
                        :border="false"
                        input-align="right"
                        error-message-align="right"
                        clearable
                        placeholder="请输入税号"
                />
                <div class="operate-desc-left">如果您所在的单位没有纳税人识别号请填写“无”</div>

                <van-field
                        v-model="formData.fapiao_address"
                        label="地址"
                        input-align="right"
                        error-message-align="right"
                        clearable
                        placeholder="（非必填）发票购买方地址"
                />
                <van-field
                        v-model="formData.fapiao_tel"
                        label="电话"
                        input-align="right"
                        error-message-align="right"
                        clearable
                        placeholder="（非必填）发票购买方电话"
                />
                <van-field
                        v-model="formData.fapiao_account"
                        label="开户行及账号"
                        input-align="right"
                        error-message-align="right"
                        clearable
                        placeholder="（非必填）发票购买方开户行及账号"
                />

                <van-field
                        v-model="formData.fapiao_beizhu"
                        label="备注"
                        input-align="right"
                        clearable
                        placeholder="请输入备注"
                />
                <div class="operate-desc-left">不会体现在发票上，仅显示给管理员</div>
                <van-field
                        v-model="formData.fapiao_email"
                        :rules="[{ validator: validator.email, message: '请输入正确的邮箱' }]"
                        error-message-align="right"
                        label="接收邮箱"
                        input-align="right"
                        clearable
                        placeholder="请输入接收邮箱"
                />
                <van-field
                        v-model="formData.fapiao_phone"
                        :rules="[{ validator: validator.phone,message:'请输入正确的手机号'}]"
                        error-message-align="right"
                        label="接收手机"
                        input-align="right"
                        clearable
                        placeholder="请输入接收手机"
                />
            </van-cell-group>
            </div>


            <!-- <van-divider  v-if="formData.can_fc" > 队伍风采口号</van-divider> -->

 
            <!-- <van-cell-group  v-if="formData.can_fc"> -->
            <van-cell-group  v-if="false">

                <van-field
                        v-model="formData.kouhao"
                        :rules="[]"
                        label="队伍口号"
                        maxlength="15"
                        show-word-limit
                        input-align="right"
                        autosize
                        type="textarea"
                        error-message-align="right"
                        clearable
                        placeholder="请输入队伍口号"
                /> 
                <van-cell title="队伍风采视频" :value="formData.fc_pic.length+'/1'">
                    <template slot="icon" >
                        <van-icon class="question-icon" name="question-o" @click="onQuestion('heying')"/>
                    </template>
                </van-cell>

                <div class="row">
                    <PicUploader :fileList="formData.fc_pic" :limit="1"
                                 :name="'fc_pic'"></PicUploader>
                </div>
                <div class="operate-desc-left">请上传队伍风采视频的二维码图片</div>
            </van-cell-group> 


            <div class="savebtn">
                <van-button
                        color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                        style="width: 3rem"
                        size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..." @click="submit">下一步</van-button>
            </div>
        </van-form>


        <CaipanPicker
                :show="showCaipanPicker"
                :limit="saiqu_id==648?2:1"
                :danweiId="formData.danwei_id"
                @onChange="onCaipanChange"
                @onClose="showCaipanPicker=false"
                :defaultValue="formData.caipan"
                @onConfirm="onCaipanConfirm"
        ></CaipanPicker>


        <JiaolianPicker
                :show="showJiaolianPicker"
                :limit="5"
                :danweiId="formData.danwei_id"
                @onChange="onJiaolianChange"
                @onClose="showJiaolianPicker=false"
                :defaultValue="formData.jiaolian"
                @onConfirm="onJiaolianConfirm"
        ></JiaolianPicker>

        <LoginDialog :show="loginShow" @loginSuccess="loginSuccess" @loginCancel="loginCancel" />

        <FapiaoPicker :show="fapiaoPickerShow" @onChange="changeFapiao" @onClose="closeFapiao" />

        <NavFloatService v-if="saiqu_id==648" @show="showKefu = true"></NavFloatService>
        <van-dialog v-model="showKefu">
        <div style="width: 80%; text-align: center ; margin: 10px auto ;  font-size:14px;">
             比赛负责:孙健明 18020182507 <van-button  
                        v-clipboard:copy="18020182507"
                        v-clipboard:success="onCopy"
            >复制</van-button><br/>
             赛事咨询:王 悠 18020182792 <van-button  
                        v-clipboard:copy="18020182792"
                        v-clipboard:success="onCopy"
            >复制</van-button><br/>
             赛事咨询:高 翔 18020182729 <van-button  
                        v-clipboard:copy="18020182729"
                        v-clipboard:success="onCopy"
            >复制</van-button><br/>
              
             </div>
        </van-dialog>
    </div>
</template>
<style scoped>
    .box {
        /*margin-bottom: 1.5rem;*/
    }

    .memberResultWrap{
        background: #F3F3F3;
        margin: 0.2rem;
        border-radius: 8px;
        padding: 0.2rem;
    }
    .memberResultWrap .memberLi{
        font-size: 14px;
        color: #666;
        height: 36px;
        line-height: 36px;
    }
    .memberResultWrap .memberLi .van-tag{
        width: auto !important;
    }

    .savebtn {
        position: fixed;
        bottom: 0;
        padding-bottom: 0.2rem;
        width: 100%;
        z-index: 10;
        display: flex;
        flex: 1;
        flex-direction: row;
        justify-content: space-around;
        background: linear-gradient(180deg,hsla(0,0%,100%,0),#fff);
    }


    .van-tag {
        width: 55px;
        margin-left: 10px;
        text-align: center;
    }
    .between {
        justify-content: space-between;
    }


</style>
<script>
    import Vue from 'vue';
    import area from "../../../utils/area";
    import validator from "../../../utils/validator";
    import PicUploader from '@/components/picker/PicUploader.vue';
    import FapiaoPicker from "@/components/FapiaoPicker.vue"; 

    import {Cell,Field,Area,Form,Divider, CellGroup,RadioGroup,Radio,Icon,Dialog, Toast, Popup, Picker, Sidebar, SidebarItem, Tag, Stepper ,Switch ,Button} from 'vant';
    import CaipanPicker from '@/components/picker/CaipanPicker.vue';
    import JiaolianPicker from '@/components/picker/JiaolianPicker.vue';
    import LoginDialog from '@/components/LoginDialog.vue';
    import NavFloatService from "@/components/NavFloatService.vue";

    Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Area).use(RadioGroup).use(Dialog).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
            .use(Switch).use(Button);
    export default {
        name: 'SaiApplyFormStep1',
        components: {
            [Field.name]: Field,
            PicUploader,
            CaipanPicker,
            JiaolianPicker,
            LoginDialog,
            FapiaoPicker, 
            NavFloatService,
        },
        data: function () {
            return {
                validator,
                fapiaoPickerShow:false,
                loginShow:false,
                saveLoading:false,
                showKefu:false,
                saiqu_id: this.$route.query.saiqu_id,
                showCaipanPicker:false,
                showJiaolianPicker:false,
                showNumTypePicker:false,
                showDanweiPicker:false,
                numTypeColumns: ['身份证', '护照', '其他'], 
                danweiColumns: [{
                    'name':'单位1',
                    'id':1
                },{
                    'name':'单位2',
                    'id':2
                },{
                    'name':'单位3',
                    'id':3
                }],
                defaultDanweiIndex:0,
                fengongsiColumns:[],
                defaultFengongsiIndex:0,
                showFengongsiPicker:false, 
                showArea:false,
                areaList:{},
                areaValue:'',
                submitType:'',
                clockSecond:0,
                danwei_options:[],
                
                formData: {
                    id:0,
                    saiqu_name:'',
                    numTypeName:'身份证',
                    danwei:'',
                    fengongsi:'',
                    fengongsi_id:'',
                    dx_area:'',
                    dx_province:'',
                    dx_city:'',
                    mingcheng:'',
                    mingcheng_end:'',

                    fapiao_shuihao:'',
                    fapiao_account:'',
                    fapiao_tel:'',
                    fapiao_address:'',
                    
                    fapiao_beizhu:'',
                    fapiao_email:'',
                    fapiao_phone:'', 


                    ldcardtype:1,
                    ldsex:1,
                    danwei_options:[],
                    heying: [],
//                            [{name:"选择商户.png",
//                        save_name:"h5/2020-05-11/1589187988243621.png",
//                        uid:"vc-upload-1589187988243621",
//                        url:"https://cheeseman.oss-cn-hangzhou.aliyuncs.com/h5/2020-05-11/1589187988243621.png"
//                    }],
                    caipan:[],
                    jiaolian:[],
                    kouhao:'',
                    fc_pic:[],
                    can_fc:false,
                },
            }
        },
        filters: {},
        mounted() {
            let that = this;
            that.areaList = area;
            that.formData.id = this.$route.query.id;
            document.title = '队伍信息填写';
            this.fetch1();
            this.getDanweiOptions()
            setTimeout(() => {
                that.danweiColumns.map((item,index)=>{
                    console.log(item.id,that.formData.gongsi_id)
                    if(item.id == that.formData.gongsi_id){
                        that.defaultDanweiIndex = index;
                        that.fengongsiColumns = item.list;
                        that.fengongsiColumns.map((item2,index2)=>{
                            if(item2.id == that.formData.fengongsi_id){
                                that.defaultFengongsiIndex = index2;
                            }
                        })
                        return 
                    }
                })
            }, 1000);
        },
        watch: {
            formData() {
            }
        },
        destroyed() {
        },
        methods: {

            fetch1(){
                let that = this;
                that.$api.get('/api/isai/step1Detail', {
                    saiqu_id : that.saiqu_id,
                    id : that.formData.id,
                }, (res) => { 
                    if(res.data.notice){
                        Dialog.confirm({
                        title: '报名须知',
                        message: res.data.notice,
                        confirmButtonText:'同意并开始报名',
                        cancelButtonText:'不报名了'
                        }).then(() => {
                        // on close
                            that.fetch();
                        }).catch(() => {
                            rbLink({
                                name:'',
                            },'back')
                        });;
                        return ;
                    }else{
                        that.fetch();
                    }

                },(res) =>{

                    console.log('没有登录');
                    if (res.code == 401 || res.code==402) {
                        if(window.isApp()){
                            rbLink({
                                name:'login','query':{ }
                            },'replace');
                            return false;
                        }
                        that.loginShow = true
                    }else {
                        Toast(res.msg)
                    }
                })
            },
            fetch(){
                let that = this;
                that.$api.get('/api/isaidianxin/step1Detail', {
                    saiqu_id : that.saiqu_id,
                    id : that.formData.id,
                }, (res) => {
                    that.formData = Object.assign(that.formData, res.data); 
                    that.saiqu_id = that.formData.saiqu_id 

                    if(that.formData.danwei_status==0){
                        Dialog.alert({
                            title: '请先认证',
                            message: '报名前请先进行单位信息的备案或者绑定',
                            confirmButtonText:'进行单位认证或绑定'
                        }).then(() => {
                            // on close
                            rbLink({
                                name:'CertDanwei'
                            })
                        });
                    }else if(that.formData.danwei_status==1){
                        Dialog.alert({
                            title: '请等待认证审核',
                            message: '您的单位信息正在审核请耐心等待审核通过',
                            confirmButtonText:'查看详情'
                        }).then(() => {
                            // on close
                            rbLink({
                                name:'CertDanweiResult'
                            })
                        });
                    }else if(that.formData.danwei_status==3){
                        Dialog.alert({
                            title: '单位认证未通过',
                            message: '您的单位信息未通过审核',
                            confirmButtonText:'查看详情'
                        }).then(() => {
                            // on close
                            rbLink({
                                name:'CertDanweiResult'
                            })
                        });
                    }else if(that.formData.jiaolian_count==0){
                        Dialog.alert({
                            title: '没有注册教练员信息',
                            message: '请先注册教练员信息',
                            confirmButtonText:'立即注册'
                        }).then(() => {
                            // on close
                            rbLink({
                                name:'JiaolianList'
                            })
                        });
                    }else if(that.formData.un_complete>0){
                        Dialog.setDefaultOptions({
                            'confirmButtonText':'继续未完成的报名',
                            'cancelButtonText':'重新报名',
                        })
                        Dialog.confirm({
                            title: '您有未完成的报名',
                            message: '建议您选择继续未完成的报名'
                        }).then(() => {
                            that.jumToOld();
                        }).catch(() => {
                        });
                    }


                },(res) =>{
                    console.log('没有登录');
                    if (res.code == 401 || res.code==402) {
                        if(window.isApp()){
                            rbLink({
                                name:'login','query':{ }
                            },'replace');
                            return false;
                        }
                        that.loginShow = true
                    }else { 
                        Toast({
                        message: '啦啦之星提示您:'+res.msg,
                        iconSize:'300px',
                        icon: 'https://api.ccachina.net/public/images/icon-lalazhixing.png',
                        });
                    }
                })
            },
            onQuestion(){
                console.log('onQuestion')
            },
            getDanweiOptions(){ 
                let that = this;
                that.$api.get('/api/isaidianxin/danweioptions', {
                    saiqu_id : that.saiqu_id,
                    id : that.formData.id,
                }, (res) => { 
                    that.danweiColumns = res.data;
                },(res) =>{ 
                })
            },
            onCaipanConfirm(values){
                console.log('onCaipanConfirm',values)
                this.showCaipanPicker = false;
                this.formData.caipan = [...values];
            },
            onCaipanChange(values){
                console.log('onCaipanChange',values)
                this.formData.caipan = [...values];
            },
            onCaipanConfirm(values){
                console.log('onCaipanConfirm',values)
                this.showCaipanPicker = false;
                this.formData.caipan = [...values];
            },
            onCaipanChange(values){
                console.log('onCaipanChange',values)
                this.formData.caipan = [...values];
            },
            onJiaolianConfirm(values){
                console.log('onJiaolianConfirm',values)
                this.showJiaolianPicker = false;
                this.formData.jiaolian = [...values];
            },
            onJiaolianChange(values){
                console.log('onJiaolianChange',values)
                this.formData.jiaolian = [...values];
            },
            onNumTypeConfirm(value, index){
                this.formData.numTypeName = value;
                this.formData.ldcardtype = index+1;
                this.showNumTypePicker = false;
            },
            onDanweiConfirm(value, index){
                console.log('onDanweiConfirm',value, index);
                this.formData.gongsi = value.name;
                this.formData.danwei = value.name;
                this.formData.danwei_id = value.id;
                this.formData.gongsi_id = value.id;
                this.formData.dx_area = value.area;
                this.formData.dx_province = value.province;
                this.formData.dx_city = value.city; 
                this.showDanweiPicker = false;
                this.fengongsiColumns = value.list;
                this.formData.fengongsi = '';
                this.formData.fengongsi_id = '';
                this.defaultFengongsiIndex = 0;
            },
            onFengongsiConfirm(value, index){
                console.log('onFengongsiConfirm',value, index);
                this.formData.fengongsi = value.name;
                this.formData.fengongsi_id = value.id;
                this.formData.danwei_id = value.id;
                this.formData.danwei = this.formData.gongsi+value.name;
                this.formData.dx_area = value.area;
                this.formData.dx_province = value.province;
                this.formData.dx_city = value.city; 
                this.showFengongsiPicker = false;
            },
            jumToOld(id){
                rbLink({
                    name:'ISaiApplyListDianxin'
                },'replace')
            },
            onSubmit(values){
                console.log('onSubmit-values',values);
                console.log('submitType',this.submitType);

                let that = this;
                console.log(that.formData)
                that.formValidate = true;
                if (!that.formData.danwei) {
                    Toast('请选择单位');
                    return
                } 
                // if(that.formData.danwei_id<112638&&that.formData.danwei_id>112593 &&that.formData.dx_area.substring(2, 4) =='00'){
                if(that.formData.gongsi_id<112638&&that.formData.gongsi_id>112593 ){
                    
                    // Toast('请选择省市');
                    if(!that.formData.fengongsi){
                        Toast('请选择分公司');
                        return
                    } 
                } 
                for (let field in that.formData) {

                    if (that.formData.heying.length == 0) {
                        Toast('请上传队伍照片');
                        return
                    }
                    if (this.formData.jiaolian.length==0) {
                        // Toast('请至少选择一位教练');
                        // return
                    }
                }
                that.saveLoading = true;
                that.$api.post('/api/isaidianxin/baoming', that.formData, (res) => {
                    that.saveLoading = false;

                    appEvent({
                        name: 'saiApplyDetailReload',
                        query: {
                        }
                    });
                    setTimeout(function () {
                        rbLink({
                            'name' : 'ISaiApplyDetailDianxin',
                            'query':{
                                id:res.data.id
                            }
                        },'replace')
                    },50);
                }, (res) => {
                    if(res.code == 505){
                        Dialog.alert({
                            title: '等待认证',
                            message: res.msg,
                            confirmButtonText:'查看详情'
                        }).then(() => {
                            // on close
                            rbLink({
                                name:'CertDanwei'
                            })
                        });
                    }else{
                        Toast.fail(res.msg);
                    }
                    that.saveLoading = false;
                })
            },
            save(values){
                this.submitType = 'save';
            },
            onFailed(errorInfo){
                console.log('failed', errorInfo);
            },
            submit(values) {
                this.submitType = 'submit';
            },

            loginSuccess(res){
                console.log('-------登录成功--------',res);
                this.loginShow = false;
                this.fetch();
            },

            loginCancel(){
                console.log('-------取消登录--------');
                // this.loginShow = false;
            },
            heyingChange(data){
                console.log('heying',data);
                let that = this;
                if(data.pic.length>0){
                    // 创建对象
                    var img = new Image(); 
                    // 改变图片的src
                    img.src = data.pic[0].url; 
                    // 打印
                    img.onload = function(){
                        // 打印
                        if(img.width<img.height){ 
                            Toast('请上传横版图片');
                            that.formData.heying =[];
                            return ;
                        } 
                    }
                }
            },

            changeFapiao(fapiao) {
                let that = this;
                console.log("更换", fapiao);
                that.fapiaoPickerShow = false;

                that.formData.fapiao_taitou = fapiao.taitou;  
                that.formData.fapiao_shuihao = fapiao.shuihao;  
                that.formData.fapiao_account = fapiao.account;  
                that.formData.fapiao_tel = fapiao.phone;  
                that.formData.fapiao_address = fapiao.address;  
            },
            closeFapiao() {
                let that = this;
                console.log("close");
                that.fapiaoPickerShow = false;
            },

            onCopy() {
                Toast.success('复制成功') 
            },

            onAreaConfirm(values) {
                console.log(values);
                this.formData.dx_area = values[1].code;
                this.formData.dx_province = values[0].name;
                this.formData.dx_city = values[1].name; 
                this.showArea = false;
            },

            getCode() {
                let that = this;
                if (that.clockSecond > 0) {
                    return;
                }
                if (!that.formData.lxphone) {
                    Toast('请输入手机号')
                    return;
                }
                /*if (!that.formData.code) {
                    Toast('请输入验证码')
                    return;
                }*/
                that.$api.get('/api/index/phonecode', {phone: that.formData.lxphone}, (res) => {
                    Toast(res.msg);
                })

                that.clockSecond = 60;

                var t = setInterval(function () {
                    if (that.clockSecond > 0) {
                        that.clockSecond = that.clockSecond - 1;
                    } else {
                        clearInterval(t);
                    }
                }, 1000)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// SaiApplyFormStep1Dianxin.vue?4a7966be